import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";

const colors = {
  successBg: "#E6F7F0",
  textPrimary: "#222",
  textSecondary: "#555"
};

export default makeStyles((theme) => ({
  pageContent: {
    backgroundColor: "white",
    width: "100%",
    // height: "100%",
    borderRadius: "10px 10px 0px 0px",
    boxSizing: "border-box",
    paddingBlock: "10px",
    paddingInline: "16px",
    "@media (max-width: 600px)": {
      backgroundColor: "transparent",
      paddingInline: 0,
      paddingBlock: 0
    }
  },
  inline: {
    paddingInline: "20px"
  },
  contentpadding: {
    paddingLeft: 10
  },
  buttoncountcontainer: {
    marginTop: 15,
    marginBottom: 15
  },
  paddingleftmodal: {
    paddingLeft: "3%",
    marginBlock: "21px 26px",
    display: "flex",
    gap: "10px",
    width: "100%"
  },
  ExamItems: {
    marginLeft: "30px",
    marginBottom: "24px"
  },
  mail: {
    paddingLeft: "3%",
    gap: "2px",
    color: "#0065FF",
    fontWeight: "500",
    lineHeight: "17.4px"
  },
  label: {
    fontWeight: "500",
    fontSize: "16px",
    textAlign: "left",
    "& p": {
      textAlign: "left",
      fontWeight: "500",
      fontSize: "16px"
    }
  },
  pickercontainer: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    maxHeight: 70,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    marginBottom: 20,
    marginTop: 15
  },
  picker: {
    opacity: 0,
    width: "100%",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: "100%",
    cursor: "pointer",
    position: "absolute"
  },
  uploadbutton: {
    backgroundColor: "#CB1A14",
    width: 120,
    height: 39,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    gap: 5,
    color: "white",
    position: "relative",
    zIndex: 50,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  uploadflex: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  uploadicon: {
    fontSize: 16,
    color: "#101928"
  },
  uploadtitle: {
    fontSize: 16,
    color: "#101928",
    marginBottom: 0,
    marginTop: 0
  },
  uploadsubtitle: {
    color: "#98A2B3",
    fontsize: 16,
    marginBottom: 0,
    marginTop: 0
  },
  remove: {
    color: "red",
    position: "relative",
    alignItems: "center",
    gap: 4,
    padding: "6px 8px",
    boxSizing: "border-box",
    marginLeft: 3,
    zIndex: 50,
    backgroundColor: "white",
    border: "1px solid #98A2B3",
    borderRadius: 4,
    display: "flex",
    fontWeight: "bold"
  },
  // Report Template
  logoContent: {
    height: "50px",
    filter: "brightness(0) saturate(100%) invert(1)"
  },
  reportheader: {
    // backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.7).toRgbString(),
    backgroundColor: theme.palette.primary.main,
    padding: "36px",
    color: "#FFFFFF",
    textAlign: "center",
    "& h1": {
      fontWeight: 700,
      fontSize: "20px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      color: "#FFFFFF",
      margin: "0px"
    }
  },
  imageWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
  },
  profiledata: {
    textAlign: "left",
    "& h6": {
      fontWeight: 400,
      fontSize: "12px",
      marginBlock: "0px",
      color: "#6D6D6D"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      marginBlock: "0px",
      color: "#344054"
    }
  },
  profile: {
    height: "80px",
    border: "1px solid #FFFFFF",
    "@media (max-width: 600px)": {
      marginTop: "10px"
    }
  },
  termdata: {
    marginBlock: "20px",
    width: "100%",
    padding: "8px",
    backgroundColor: theme.palette.primary.main,
    "& h1": {
      fontWeight: 700,
      fontSize: "16px",
      marginBlock: "0px",
      textAlign: "center",
      color: "#FFFFFF"
    }
  },
  container: {
    position: "relative",
    backgroundColor: "#f9fafc",
    borderRadius: 12,
    padding: 10,
    height: "100%",
    border: "1px solid #e0e0e0"
  },
  title: {
    fontWeight: 600,
    marginBottom: "1.5rem",
    fontSize: "1.25rem",
    color: "#111"
  },
  card: {
    borderRadius: 12,
    overflow: "hidden",
    border: "1px solid transparent",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "&:hover": {
      borderColor: "#1976d2"
    }
  },
  activeCard: {
    borderColor: "#1976d2",
    boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.3)"
  },
  mycards: {
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.1).toRgbString(),
    padding: "10px",
    marginRight: "10px",
    borderRadius: "8px"
  },
  lockedCard: {
    filter: "blur(2px)",
    cursor: "not-allowed"
  },
  image: {
    width: "100%",
    height: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
    "& svg": {
      width: "100%",
      height: "auto",
      maxHeight: 260,
      objectFit: "contain"
    }
  },
  templateName: {
    textAlign: "center",
    padding: "0.45rem 0",
    fontWeight: 500,
    fontSize: "0.95rem",
    color: "#333",
    margin: 0
  },
  locknote: {
    width: "97%",
    position: "absolute",
    bottom: "10px",
    right: "10px",
    left: "10px",
    display: "flex",
    alignItems: "flex-start",
    gap: "6px",
    justifyContent: "flex-start",
    textAlign: "left",
    marginTop: "1.5rem",
    background: "#fff",
    padding: "0.75rem 1rem",
    borderRadius: 8,
    border: "1px dashed #ccc",
    fontSize: "0.85rem",
    color: "#555",
    "& p": {
      marginBlock: "0px"
    }
  },
  // SECOND TEMPLATE UI
  secondreportmain: {
    position: "relative"
  },
  secondreportheader: {
    // backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.7).toRgbString(),
    // backgroundColor: "#E0E0E0",
    padding: "36px",
    color: theme.palette.primary.main,
    textAlign: "center",
    "& h1": {
      fontWeight: 700,
      fontSize: "20px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      margin: "0px"
    }
  },
  secondlogoContent: {
    height: "50px"
  },
  stdninfo: {
    paddingInline: "16px"
  },
  topBorderWrapper: {
    position: "relative",
    width: "100%",
    height: "40px",
    backgroundColor: "#fff",
    overflow: "hidden"
  },
  topBorder: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "40px",
    width: "100%",
    backgroundColor: theme.palette.primary.main,
    clipPath: "polygon(0 0, 94% 0, 93% 40%, 0 40%)"
  },
  topBorderInner: {
    position: "absolute",
    top: 10,
    right: 0,
    height: "10px",
    width: "100%",
    backgroundColor: "#fff",
    clipPath: "polygon(6% 0, 100% 0, 100% 100%, 7% 100%)"
  },
  secondtermdata: {
    marginBlock: "20px",
    width: "100%",
    padding: "16px 8px 8px 8px",
    // backgroundColor: theme.palette.primary.main,
    "& h1": {
      fontWeight: 700,
      fontSize: "16px",
      marginBlock: "0px",
      textAlign: "center",
      color: theme.palette.primary.main
    }
  },
  tembottomimage: {
    width: "100%",
    fill: theme.palette.primary.main
  },
  borderleftright: {
    borderLeft: `2px solid ${theme.palette.primary.main} `,
    borderRight: `2px solid ${theme.palette.primary.main} `
  },
  linescontainer: {
    display: "flex",
    flexDirection: "column",

    gap: "6px",
    width: "100%",
    // maxWidth: "400px",
    alignItems: "center"
  },
  line1: {
    height: "2.97px",
    width: "60%",
    backgroundColor: theme.palette.primary.main
  },
  line2: {
    height: "2.97px",
    width: "65%",
    backgroundColor: theme.palette.primary.main
  },
  line3: {
    height: "2.97px",
    width: "60%",
    backgroundColor: theme.palette.primary.main
  },
  check: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px"
  },
  copy: {
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(45).toHexString(),
    padding: "1rem 1.5rem"
  },
  details_span: {
    color: "#667185",
    fontSize: "12px"
  },
  details_p: {
    fontWeight: 500,
    fontSize: "14px",
    margin: 0
  },
  note: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13px",
    marginTop: "10px"
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 30000,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  modalCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
    padding: theme.spacing(4),
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)"
  },

  iconWrapper: {
    height: "56px",
    width: "56px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    marginBottom: theme.spacing(2)
  },
  successIconBg: {
    backgroundColor: colors.successBg
  },
  iconImg: {
    width: "28px",
    height: "28px"
  },
  warningIconImg: {
    width: "56px",
    height: "56px",
    marginBottom: theme.spacing(2)
  },

  heading: {
    fontSize: "20px",
    fontWeight: 600,
    color: colors.textPrimary,
    margin: `0 0 ${theme.spacing(1)}px 0`
  },
  body: {
    fontSize: "14px",
    color: colors.textSecondary,
    lineHeight: 1.5,
    margin: `0 0 ${theme.spacing(3)}px 0`
  },

  modalFooter: {
    width: "100%",
    padding: "12px 24px",
    backgroundColor: theme.palette.primary.main,
    color: "#FFFFFF",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer"
  },
  tableContainer: {
    marginTop: theme.spacing(2),
    boxShadow: "none",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "8px",
    overflow: "hidden"
  },
  table: {
    minWidth: 650
  },
  tableHead: {
    backgroundColor: "#f8f9fa"
  },
  tableHeader: {
    fontWeight: "600",
    fontSize: "14px",
    color: theme.palette.text.primary,
    borderBottom: `2px solid ${theme.palette.divider}`,
    borderRight: `1px solid ${theme.palette.divider}`,
    "&:last-child": {
      borderRight: "none"
    }
  },
  tableRow: {
    "&:last-child td, &:last-child th": {
      borderBottom: 0
    }
  },
  tableCell: {
    padding: "12px 16px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRight: `1px solid ${theme.palette.divider}`,
    "&:last-child": {
      borderRight: "none"
    }
  },
  studentName: {
    fontWeight: "500",
    color: theme.palette.text.primary
  },
  studentEmail: {
    color: theme.palette.text.secondary,
    fontSize: "14px"
  },
  studentPassword: {
    fontFamily: "monospace",
    backgroundColor: "#f5f5f5",
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "12px",
    color: theme.palette.text.primary
  },
  validBadge: {
    backgroundColor: "#d4edda",
    color: "#155724",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "500"
  },
  invalidBadge: {
    backgroundColor: "#f8d7da",
    color: "#721c24",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "500"
  },
  summaryStats: {
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
    padding: "16px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px"
  },
  statItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  statNumber: {
    fontSize: "24px",
    fontWeight: "bold"
  },
  statLabel: {
    fontSize: "12px",
    color: theme.palette.text.secondary
  },
  noDataMessage: {
    textAlign: "center",
    padding: "40px",
    color: theme.palette.text.secondary
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 500px)": {
      flexWrap: "wrap"
    }
  }
}));
